import type { Action } from 'state/actions';

import type { FilterState } from './filter.model';
import { initialFilterState } from './filter.model';

export function filterReducer(state: FilterState = initialFilterState(), action: Action): FilterState {
  switch (action.type) {
    case 'DASHBOARD_QUICK_SEARCH_TERM_CHANGED':
      return { ...state, quickSearchTerm: action.term };
    case 'DASHBOARD_FILTER_TYPE_CHANGED':
      return { ...state, type: action.filterType };
    case 'DASHBOARD_BY_STATUS_FILTER_CHANGED':
      return { ...state, status: action.status };
    case 'DASHBOARD_BY_CLIENT_FILTER_CHANGED':
      return { ...state, client: action.client, product: action.product };
    case 'DASHBOARD_BY_PINNED_FILTER_CHANGED':
      return { ...state, pinnedGroup: action.pinnedGroup };
    case 'DASHBOARD_PINNED_GROUP_RENAMED':
      return action.previousName === state.pinnedGroup ? { ...state, pinnedGroup: action.newName } : state;
    default:
      return state;
  }
}
